import type { GameAdapter, MatchSummaryPatch, PlayerId } from "../game-core";
import {
  activePlayer,
  createInitialState,
  isTerminal,
  legalMoves,
  reduce,
  validateMove,
  validateState,
  type OthelloMove,
  type OthelloState,
} from "./engine";

export const othelloAdapter: GameAdapter<OthelloState, OthelloMove> = {
  gameId: "othello",
  rulesVersion: "othello/1",
  displayName: "Othello",
  tagline: "Flip the board. Own the corners.",

  createInitialState: (players, at) => createInitialState(players, at),
  validateState,
  legalMoves,
  validateMove,
  reduce,
  activePlayer,
  players: (state) => state.players,
  revision: (state) => state.revision,
  isTerminal,

  summarize(state: OthelloState, me: PlayerId): MatchSummaryPatch {
    const myColor = state.match.colors[me];
    const oppColor = myColor === "dark" ? "light" : "dark";
    const myScore = state.discCounts[myColor] ?? 0;
    const opponentScore = state.discCounts[oppColor] ?? 0;

    if (isTerminal(state)) {
      const result =
        state.match.outcome === "draw"
          ? "draw"
          : state.match.winnerId === me
            ? "won"
            : "lost";
      return { myScore, opponentScore, status: "finished", result };
    }
    return {
      myScore,
      opponentScore,
      status: state.match.activePlayerId === me ? "your-turn" : "waiting",
    };
  },
};
